import {createContext, useContext, useEffect, useState} from "react";
import axios from "axios";
import {LoadingContext} from "./LoadingContext";

const VideoContext = createContext();

const VideoContextProvider = ({children}) => {
    const [data, setData] = useState();
    const {showLoading, hideLoading} = useContext(LoadingContext);

    const getByIdVideo = (id) => {
       let res =  data?.videos?.find(video => video.id === id);
       return res;
    }


    const getData = () => {
        showLoading();
        axios.get("https://obbtv.com/ytbot/")
            .then(res => {
                setData(res.data)
                hideLoading();
            }).catch(err => {
                hideLoading();
        });
    }

    useEffect(() => {
       getData()
    },[])

    return (
        <VideoContext.Provider value={{
            youtubeData: data,
            getByIdVideo
        }}>
            {children}
        </VideoContext.Provider>
    )
}

export {VideoContext, VideoContextProvider};